import { NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { DragDirective } from './directives/drag.directive';
import { OnlyDoubleInputDirective } from './directives/only-double-input.directive';
import { OnlyNumberInputDirective } from './directives/only-number-input.directive';
import { ResizedDirective } from './directives/resized.directive';
import { LanguageLoader } from './languages/languageLoader';
import { QuitarBarraBajaPipe } from './pipes/quitar-barra-baja.pipe';
import { SafeHtmlPipe } from './pipes/safe-html-pipe';
import { SafePipe } from './pipes/safe.pipe';
import { UtcDatePipe } from './pipes/utc-date-pipe';
import { AbsorcionGrupoService } from './services/absorcion-grupo.service';
import { AlbaranService } from './services/albaran.service';
import { AlertasService } from './services/alertas.service';
import { AlmacenService } from './services/almacen.service';
import { AuthGuardService } from './services/auth-guard.service';
import { AuthenticationService } from './services/authentication.service';
import { CargaMasivaService } from './services/carga-masiva.service';
import { ClientesService } from './services/clientes.service';
import { ContactoService } from './services/contacto.service';
import { ContenidosService } from './services/contenidos.service';
import { DepartamentosSeriesService } from './services/departamentos-series.service';
import { DetalleService } from './services/Detalle/detalle.service';
import { DireccionesService } from './services/direcciones.service';
import { EstadosService } from './services/estados.service';
import { FileManagerService } from './services/files/file-manager.service';
import { FlujoAprobacionesService } from './services/flujo-aprobaciones.service';
import { GruposService } from './services/grupos.service';
import { HighlightService } from './services/highlight.service';
import { HistoryService } from './services/history.service';
import { ImagenCacheBufferService } from './services/imagen-cache-buffer.service';
import { FileDownloaderService } from './services/informes/file-downloader.service';
import { InformesService } from './services/informes/informes.service';
import { FileUploaderService } from './services/informes/upload-file.service';
import { InstruccionesService } from './services/instrucciones.service';
import { InventariosService } from './services/inventarios.service';
import { MaterialesService } from './services/materiales.service';
import { ObservacionesSolicitudService } from './services/observaciones-solicitud.service';
import { OCRService } from './services/ocr.service';
import { ParametrosServicioService } from './services/parametros-servicio.service';
import { PasswordResetService } from './services/password-reset.service';
import { PdfService } from './services/pdf.service';
import { PopulateService } from './services/populate.service';
import { ProveedoresService } from './services/proveedores.service';
import { RequestStateService } from './services/request-state.service';
import { SeriesService } from './services/series.service';
import { ServiceConfigService } from './services/service-config.service';
import { ShoppingElementsService } from './services/shopping-elements.service';
import { SituacionesService } from './services/situaciones.service';
import { SolicitudServicioService } from './services/solicitud-servicio.service';
import { SsoService } from './services/sso.service';
import { TemplatesService } from './services/templates.service';
import { TipoServicioService } from './services/tipo-servicio.service';
import { UsersService } from './services/users.service';
import { UtilitiesService } from './services/Utility/utilities.service';



@NgModule({
  imports: [
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: LanguageLoader
      }
    }),
  ],
  declarations: [OnlyNumberInputDirective,
    ResizedDirective,
    OnlyDoubleInputDirective,
    SafeHtmlPipe,
    UtcDatePipe,
    DragDirective,
    SafePipe,
    QuitarBarraBajaPipe
  ],
  providers: [
    UsersService,
    AuthenticationService,
    AuthGuardService,
    TemplatesService,
    SolicitudServicioService,
    SolicitudServicioService,
    DepartamentosSeriesService,
    FileUploaderService,
    InformesService,
    PopulateService,
    FileDownloaderService,
    PasswordResetService,
    DireccionesService,
    TipoServicioService,
    SeriesService,
    ParametrosServicioService,
    ObservacionesSolicitudService,
    FlujoAprobacionesService,
    ServiceConfigService,
    DetalleService,
    AlbaranService,
    InstruccionesService,
    UtilitiesService,
    RequestStateService,
    CargaMasivaService,
    AlertasService,
    AlmacenService,
    MaterialesService,
    ContenidosService,
    InventariosService,
    ImagenCacheBufferService,
    HighlightService,
    FileManagerService,
    PdfService,
    ShoppingElementsService,
    OCRService,
    AbsorcionGrupoService,
    HistoryService,
    SituacionesService,
    ContactoService,
    ClientesService,
    SsoService,
    ProveedoresService,
    EstadosService,
    GruposService
  ],
  exports: [
    OnlyNumberInputDirective,
    ResizedDirective,
    OnlyDoubleInputDirective,
    DragDirective,
    SafePipe,
    SafeHtmlPipe,
    UtcDatePipe,
    TranslateModule,
    QuitarBarraBajaPipe
  ]
})
export class CoreModule { }
